<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Third-Party Details"></aw-bread-crumb>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Third-Party Details'"
    [altColor]="false"
    [actions]="headerButtonActions()"
  >
  </aw-divider>

  <div class="info-container">
    <div>
      @for (item of parentIntegrationInfoDividers(); track $index) {
      <div class="inset">
        <span class="aw-b-1 aw-text-secondary">{{ item.title }}</span>
        <span class="aw-b-1-medium aw-text-primary">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="divider-container">
      @for (item of parentIntegrationDateDividers(); track $index) {
      <div class="inset">
        <span class="aw-b-1 aw-text-secondary">{{ item.title }}</span>
        <span class="aw-b-1-medium aw-text-primary">{{ item.info }}</span>
      </div>
      <aw-divider></aw-divider>
      }
    </div>

    <div class="integrations-container">
      <aw-divider
        [inset]="false"
        [middleInset]="false"
        [subTitle]="'Third-Party Integrations'"
        [altColor]="true"
      >
      </aw-divider>

      <app-table-action-bar>
        <aw-search
          class="table-action-bar__search"
          [(ngModel)]="integrationSearchValue"
          (ngModelChange)="onSearchTable(integrationSearchValue)"
          ariaLabel="Search Third-Party Integrations"
          [placeholder]="'Search'"
        >
          <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
        </aw-search>

        @if (organization === 'assetworks-employee') {
        <aw-select-menu
          class="table-action-bar__filter"
          ariaLabel="Filter on Associated"
          placeholder="Filter on Associated"
          [formControl]="associatedFilter"
          [multiSelectListItems]="associatedFilterOptions"
        >
          <aw-form-field-label>Associated</aw-form-field-label>
        </aw-select-menu>
        }

        @if (organization === 'assetworks-employee' && userPermissions['canEdit']) {
        <button
          type="button"
          AwButton
          [buttonType]="'outlined'"
          [disable]="disableIntegrationChangeStatus"
          (click)="openChangeIntegrationStatus = true"
        >
          Change Status
        </button>
        <button
          type="button"
          AwButton
          [buttonType]="'outlined'"
          [disable]="disableIntegrationAssociate"
          (click)="openAssociate(checkedRows)"
        >
          Associate
        </button>
        }
      </app-table-action-bar>

      <aw-table
        [columnsDefinition]="integrationsColumnsDefinition"
        [tableData]="integrationsTableData()"
        [sortDisabled]="false"
        [optionsMenuHandler]="organization === 'assetworks-employee' ? rowActions : undefined"
        (checkboxList)="checkBoxActionHandler($event)"
      >
      </aw-table>

      <aw-dialog
        [visible]="openDisassociateIntegrationDialogSingle"
        [dialogOptions]="dialogOptionsDisassociateSingle"
        (primaryAction)="disassociateIntegrationFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('disassociate')"
        ariaLabel="Disassociate Third-Party Integration"
      >
      </aw-dialog>

      <aw-dialog
        [visible]="openChangeIntegrationStatus"
        [formFieldsData]="changeStatusFormFields()"
        [dialogOptions]="dialogOptionsChangeStatus"
        (primaryAction)="changeIntegrationStatusFormSubmit($event)"
        (secondaryAction)="dialogFormCloseHandler('change-status')"
        ariaLabel="Change Third-Party Integration Status"
      >
      </aw-dialog>

      <aw-dialog
        [visible]="openAssociateIntegrationDialog"
        [dialogOptions]="dialogOptionsAssociate"
        (primaryAction)="associateIntegrationsFormSubmit()"
        (secondaryAction)="dialogFormCloseHandler('associate')"
        ariaLabel="Associate Third-Party Integrations"
      >
      </aw-dialog>
    </div>
  </div>
</div>
